// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-buttons-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.625rem 0.625rem;
  gap: 2rem;
  flex-wrap: wrap;
}

.footer-button {
  background: var(--background-color);
  color: var(--color-primary);
  border-radius: 1.25rem;
  font-size: 1rem;
  font-weight: 600;
  border: 0.0625rem solid var(--color-primary);
  font-family: "Inter", sans-serif;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  flex: 1;
  min-width: 3rem;
  max-width: 7.5rem;
  padding: 0.5rem;
}

.reset-button {
  margin-top: 1rem;
}

.save-button {
  margin-top: 1rem;
}

.next-button {
  margin-top: 1rem;
}

.footer-button.ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {
  background-color: var(--color-primary);
  color: white;
  border-color: var(--color-primary);
}

@media (max-width: 768px) {
  .footer-buttons-container {
    flex-direction: column;
    align-items: stretch;
  }

  .footer-button {
    margin-bottom: 1rem;
  }
}

@media (max-width: 480px) {
  .footer-button {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Button/FooterButtonGroup.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,gCAAgC;EAChC,gEAAgE;EAChE,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".footer-buttons-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 0.625rem 0.625rem;\n  gap: 2rem;\n  flex-wrap: wrap;\n}\n\n.footer-button {\n  background: var(--background-color);\n  color: var(--color-primary);\n  border-radius: 1.25rem;\n  font-size: 1rem;\n  font-weight: 600;\n  border: 0.0625rem solid var(--color-primary);\n  font-family: \"Inter\", sans-serif;\n  transition: background-color 0.3s, color 0.3s, border-color 0.3s;\n  flex: 1;\n  min-width: 3rem;\n  max-width: 7.5rem;\n  padding: 0.5rem;\n}\n\n.reset-button {\n  margin-top: 1rem;\n}\n\n.save-button {\n  margin-top: 1rem;\n}\n\n.next-button {\n  margin-top: 1rem;\n}\n\n.footer-button.ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {\n  background-color: var(--color-primary);\n  color: white;\n  border-color: var(--color-primary);\n}\n\n@media (max-width: 768px) {\n  .footer-buttons-container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .footer-button {\n    margin-bottom: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-button {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
